<script setup>

import { defineEmits } from 'vue';
defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);

const handleClick = function(event) {

  // At what percent of the length of the target was clicked?
  const percentClicked = (event.offsetX / event.target.offsetWidth) * 100;

  // modulus 20
  console.log('percentClicked', percentClicked);

  // take percent from 0 to 100 and divide by 20
  const rating = Math.ceil(percentClicked / 20);

  // emit
  console.log('rating', rating);
  emit('update:modelValue', rating);
}

</script>

<template>
  <div class="star-rating-container large user-select-none">
    <div class="star-rating cursor-pointer" @click="handleClick($event)">
      <div class="star-rating-inner pointer-events-none" :title="modelValue * 20 + '%'" :style="{width : modelValue * 20 + '%'}"></div>
    </div>
  </div>
</template>